<script setup>
import { useAuthStore } from '@/stores/authStore';
import BarcodeInput from '@/components/Header/BarcodeInput.vue';
import Notification from './Header/Notification.vue';
import Draft from './Header/Draft.vue';
import Settings from './Header/Settings.vue';
import OrderMenu from './Header/OrderMenu.vue';
import Inventory from './Header/Inventory.vue';
import { useServedFrom } from '@/composables/useServedFrom';

const authStore = useAuthStore();

// Which origin the app is actually served from — green dot for production,
// grey dot + host for any local/test build.
const { isCanonical, displayHost } = useServedFrom();

</script>

<template> 
    <div class="grid grid-cols-12 gap-4 items-center mt-5 p-5 bg-white rounded-2xl relative">
        <!-- Non-production marker only: nothing on pos.metactical.com; grey dot + host on any other build. -->
        <div
            v-if="!isCanonical"
            class="absolute -top-2.5 left-1/2 -translate-x-1/2 z-10 flex items-center gap-1.5 px-2.5 py-0.5 bg-white border border-gray-200 rounded-full shadow-sm text-xs text-gray-500"
            :title="`Served from ${displayHost}`"
        >
            <span class="inline-block w-2 h-2 rounded-full bg-gray-400"></span>
            <span class="font-medium">{{ displayHost }}</span>
        </div>
        <div class="flex items-center gap-1 col-span-7 bg-gray-100 py-2 px-4 rounded-3xl">
            <i
             :disabled="!(authStore.isUserLoggedIn || authStore.isManagerLoggedIn)"
             :class="{ 'opacity-50 cursor-not-allowed': !(authStore.isUserLoggedIn || authStore.isManagerLoggedIn) }"
             class="pi pi-barcode text-purple-500"
             style="font-size: 1.875rem;"
            ></i>
            <BarcodeInput />
        </div>
        <div class="col-span-1 text-center">
            <OrderMenu />
        </div>
        <div class="col-span-1 text-center">
            <Draft />
        </div>
        <div class="col-span-1 text-center">
            <Notification />
        </div>
        <div class="col-span-1 text-center">
            <Inventory />
        </div>
        <div class="col-span-1 text-center">
            <Settings />
        </div>
    </div>

</template>

<style scoped>

</style>